import { createFileRoute } from "@tanstack/react-router";
import SideEffectsStoppedMentioning from "@/pages/articles/SideEffectsStoppedMentioning";
export const Route = createFileRoute("/side-effects-youve-stopped-mentioning")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Side Effects Youve Stopped Mentioning | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS side effects you may not have mentioned to your doctor. Learn what to watch for and when to call your provider in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Side Effects Youve Stopped Mentioning | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS side effects you may not have mentioned to your doctor. Learn what to watch for and when to call your provider in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/side-effects-youve-stopped-mentioning",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/side-effects-youve-stopped-mentioning",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SideEffectsStoppedMentioning />;
}
